<template>
  <motlet :options="motletOptions">
    <template #content>
      <v-row class="h-100">
        <v-col>
          <v-row class="h-100">
            <v-col cols="6">
              <v-card class="card-wrap">
                <v-card-title><p class="ellipsis">Enqueue Lock</p></v-card-title>
                <v-card-text class="data-area">
                  <v-row class="h-100">
                    <v-col class="text-right text-h4 mr-1 vertical-center">
                      <liquid :value="values.rawJavaEnqueueLock" :contextmenu="onContextmenuChart" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card class="card-wrap">
                <v-card-title><p class="ellipsis">Request Queue</p></v-card-title>
                <v-card-text class="data-area">
                  <v-row class="h-100">
                    <v-col class="text-right text-h4 mr-1 vertical-center">
                      <liquid :value="values.rawJavaQueue" :contextmenu="onContextmenuChart" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import Liquid from '../chart/Liquid.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    Liquid,
  },
  data() {
    return {
      motletOptions: {
        id: 'overview/system/java/SystemSummary',
        title: 'System Summary',
      },
      messages: [
        {
          name: 'rawJavaEnqueueLock',
          fields: ['lockCount'],
        },
        {
          name: 'rawJavaQueue',
          fields: ['stime'],
        },
      ],
      messageSequence: 0,
      values: {
        rawJavaEnqueueLock: 0,
        rawJavaQueue: 0,
      },
      contextmenuUrl: '/views/detailview/java/ci',
    };
  },
  watch: {
    nodes: {
      handler: 'changeNodesHandler',
    },
  },
  methods: {
    wsBufferedDataHandler(key, responses, every) {
      responses.forEach(response => {
        const last = response.length ? response[response.length - 1] : { data: [], ctime: '', empty: true };
        every(key, last.data, last.ctime, last.empty);
      });
    },
    wsDataHandler(key, response) {
      ++this.messageSequence;

      // system 별 초기화
      if (this.messageSequence == 1) {
        Object.keys(this.values).forEach(key => (this.values[key] = 0));
      }

      // 데이터 취합
      response.forEach(res => {
        // Enqueue Lock
        if (key.name == 'rawJavaEnqueueLock') {
          this.values[key.name] += parseInt(res.lockCount);
        }
        // Request Queue
        else {
          this.values[key.name]++;
        }
      });

      if (this.messageSequence == this.nodes.length) {
        this.messageSequence = 0;
      }
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.nodes.reduce(
          (acc, node) =>
            acc.concat(
              this.messages.map(message => ({
                key: { name: message.name, sstmId: node.systemId, instId: node.instanceId, nodeId: node.id },
                fields: message.fields,
                empty: false,
                handler: {
                  buffer: this.wsBufferedDataHandler,
                  every: this.wsDataHandler,
                },
              })),
            ),
          [],
        ),
      });
    },
    changeNodesHandler() {
      this.messageSequence = 0;
      this.sendMessage();
    },
  },
};
</script>

<style scoped>
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  width: 100px;
  overflow: hidden;
}
.data-area {
  height: calc(100% - 37px);
}
.vertical-center {
  /* display: flex;
  justify-content: center;
  align-items: center; */
}
</style>
